import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => (
  bindActionCreators({

  }, dispatch)
)

class SearchResultEmailByDomain extends Component {
  render() {
    const { data } = this.props
    const { administrative_contact, registrant, technical_contact, records, name_servers } = data

    return (
      <div className='email-container'>
        <h3>Domain Information</h3>
        <table><tbody>
          <tr>
            <td>Domain Name :</td>
            <td>{data.domain_name || ""}</td>
          </tr>
          <tr>
            <td>Contact Email :</td>
            <td>{data.contact_email || ""}</td>
          </tr>
          <tr>
            <td>Domain Age :</td>
            <td>{data.domain_age} (days)</td>
          </tr>
          <tr>
            <td>Registrar Name :</td>
            <td>{data.registrant_name || ""}</td>
          </tr>
          <tr>
            <td>Registrar IANAID :</td>
            <td>{data.registrar_ianaid || ""}</td>
          </tr>
          <tr>
            <td>Whois Server :</td>
            <td>{data.whois_server || ""}</td>
          </tr>
          <tr>
            <td>Status :</td>
            <td>{data.status || ""}</td>
          </tr>
          <tr>
            <td>Created Date :</td>
            <td>{data.created_date || ""}</td>
          </tr>
          <tr>
            <td>Updated Date :</td>
            <td>{data.updated_date || ""}</td>
          </tr>
          <tr>
            <td>Expires Date :</td>
            <td>{data.expires_date || ""}</td>
          </tr>

        </tbody></table>
        { registrant ?
          <div>
            <h3>Registrant</h3>
            <table><tbody>
              <tr>
                <td>Name :</td>
                <td>{registrant.name}</td>
              </tr>
              <tr>
                <td>Email :</td>
                <td>{registrant.email}</td>
              </tr>
              <tr>
                <td>Organization :</td>
                <td>{registrant.organization}</td>
              </tr>
              <tr>
                <td>Location :</td>
                <td>{[registrant.street, registrant.city, registrant.state, registrant.country_name, registrant.postal_code].map(x => x).join(", ")}</td>
              </tr>
              <tr>
                <td>Phone Number :</td>
                <td>{registrant.phone_number}</td>
              </tr>
            </tbody></table>
          </div>
          :
          <div/>
        }
        { administrative_contact ?
          <div>
            <h3>Administrative Contact</h3>
            <table><tbody>
              <tr>
                <td>Name :</td>
                <td>{administrative_contact.name}</td>
              </tr>
              <tr>
                <td>Email :</td>
                <td>{administrative_contact.email}</td>
              </tr>
              <tr>
                <td>Organization :</td>
                <td>{administrative_contact.organization}</td>
              </tr>
              <tr>
                <td>Location :</td>
                <td>{[administrative_contact.street, administrative_contact.city, administrative_contact.state, administrative_contact.country_name, administrative_contact.postal_code].map(x => x).join(", ")}</td>
              </tr>
              <tr>
                <td>Phone Number :</td>
                <td>{administrative_contact.phone_number}</td>
              </tr>
            </tbody></table>
          </div>
          :
          <div/>
        }
        { technical_contact ?
          <div>
            <h3>Technical Contact</h3>
            <table><tbody>
              <tr>
                <td>Name :</td>
                <td>{technical_contact.name}</td>
              </tr>
              <tr>
                <td>Email :</td>
                <td>{technical_contact.email}</td>
              </tr>
              <tr>
                <td>Organization :</td>
                <td>{technical_contact.organization}</td>
              </tr>
              <tr>
                <td>Location :</td>
                <td>{[technical_contact.street, technical_contact.city, technical_contact.state, technical_contact.country_name, technical_contact.postal_code].map(x => x).join(", ")}</td>
              </tr>
              <tr>
                <td>Phone Number :</td>
                <td>{technical_contact.phone_number}</td>
              </tr>
            </tbody></table>
          </div>
          :
          <div/>
        }
        <h3>Domain Records</h3>
        <table><tbody>
          <tr>
            <td>A :</td>
            <td>
              <ul>
                { records && records.a && records.a.map((item, index) =>
                  <li key={index}>{item.data}</li>
                )}
              </ul>
            </td>
          </tr>
          <tr>
            <td>MX :</td>
            <td>
              <ul>
                { records && records.mx && records.mx.map((item, index) =>
                  <li key={index}>{item.data}</li>
                )}
              </ul>
            </td>
          </tr>
          <tr>
            <td>CNAME :</td>
            <td>
              <ul>
                { records && records.cname && records.cname.map((item, index) =>
                  <li key={index}>{item.data}</li>
                )}
              </ul>
            </td>
          </tr>
        </tbody></table>
        { name_servers ?
          <div>
            <h3>Name Servers</h3>
            <table><tbody>
              <tr>
                <td>Host Names :</td>
                <td>
                  <ul>
                    { name_servers.host_names.map((item, index) =>
                      <li key={index}>{item}</li>
                    )}
                  </ul>
                </td>
              </tr>
              <tr>
                <td>IPs :</td>
                <td>
                  <ul>
                    { name_servers.ips.map((item, index) =>
                      <li key={index}>{item}</li>
                    )}
                  </ul>
                </td>
              </tr>
            </tbody></table>
          </div>
          :
          <div/>
        }
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultEmailByDomain);
